import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const playerSlice = createSlice({
  initialState: {
    audioReloadAttempts: 0 as number,
    currentTime: 0 as number,
    duration: 0 as number,
    loop: undefined as [number, number],
    playing: false,
    speed: 1 as number,
    url: undefined as string,
  },
  name: 'player',
  reducers: {
    audioReloadFailed: (state) => {
      state.audioReloadAttempts += 1
      return state
    },
    loop: (state, action: PayloadAction<[number, number]>) => {
      state.loop = action.payload
      return state
    },
    resetAudioReload: (state) => {
      state.audioReloadAttempts = 0
      return state
    },
    pause: (state) => {
      state.playing = false
      return state
    },
    play: (state) => {
      state.playing = true
      return state
    },
    seek: (state, action: PayloadAction<number>) => {
      state.currentTime = action.payload
      return state
    },
    setSpeed: (state, action: PayloadAction<number>) => {
      state.speed = action.payload
      return state
    },
    setUrl: (state, action: PayloadAction<{ url: string; duration: number }>) => {
      return {
        audioReloadAttempts: state.audioReloadAttempts,
        currentTime: 0,
        duration: action.payload.duration,
        loop: undefined,
        playing: false,
        speed: 1,
        url: action.payload.url,
      }
    },
  },
})

export const {
  audioReloadFailed,
  loop,
  pause,
  play,
  resetAudioReload,
  seek,
  setSpeed,
  setUrl,
} = playerSlice.actions
